import React from 'react';
import cn from 'classnames';

import { ProfileFallbackAvatar } from '../profileFallbackAvatar/ProfileFallbackAvatar';

import styles from './styles.module.css';

export const ProfileAnonymous = () => (
    <div className={styles.ProfileAnonymous}>
        <div className={cn(styles.contaiuner, 'text-16')}>
            <div className="profile-identity-avatar">
                <div role="img" aria-label="Bilde av en anonym avatar">
                    <ProfileFallbackAvatar className="profile-identity-avatar_img" />
                </div>
            </div>
            <div>FINN-bruker</div>
        </div>
    </div>
);
